export const environment = {
    production: false,
    apiUrl: 'https://plataforma.monitoringinnovation.com',
    db: 'plataforma_motion',
  };